import { SVGProps } from 'react'

const SvgAdmin = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M6.5 3a1 1 0 0 0-1 1v2.209a2.492 2.492 0 0 1 2 0V4a1 1 0 0 0-1-1zM12 3a1 1 0 0 0-1 1v9.207c.306-.134.644-.207 1-.207s.694.073 1 .207V4a1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1v5.709a2.492 2.492 0 0 1 2 0V4a1 1 0 0 0-1-1zM6.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM18 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-12.5.293V20a1 1 0 1 0 2 0v-9.207c-.306.134-.644.207-1 .207s-.694-.073-1-.207zM12 14a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm5 .293V20a1 1 0 1 0 2 0v-5.707c-.306.134-.644.207-1 .207s-.694-.073-1-.207zm-6 3.5V20a1 1 0 1 0 2 0v-2.207c-.306.134-.644.207-1 .207s-.694-.073-1-.207z' />
  </svg>
)

export default SvgAdmin
